var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 66,
    viewBox: "0 0 59 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3179 25.3125H30.7776V50.6404H27.3179V25.3125Z",
    fill: "#4D7CFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6316 0H24.4626C22.8564 0 21.3166 0.637778 20.1809 1.77328C19.0453 2.90886 18.4076 4.44864 18.4076 6.05494V8.33873H1.72987C0.774108 8.33873 0 9.11287 0 10.0686C0 11.0238 0.774139 11.7985 1.72987 11.7985H6.32278V54.9271C6.32278 57.6803 7.41672 60.3202 9.36331 62.2674C11.3099 64.214 13.9502 65.3073 16.7036 65.3073H41.3904C44.1436 65.3073 46.7841 64.214 48.7307 62.2674C50.6773 60.3203 51.7712 57.6805 51.7712 54.9271V11.7985H56.3641C57.3199 11.7985 58.094 11.0237 58.094 10.0686C58.094 9.11284 57.3199 8.33873 56.3641 8.33873H39.6864V6.05494C39.6864 4.4488 39.0486 2.90892 37.9131 1.77328C36.7775 0.637701 35.2377 0 33.6314 0H33.6316ZM21.8589 6.05494C21.8589 5.36648 22.1322 4.70637 22.6186 4.22003C23.1055 3.7331 23.7656 3.45976 24.4541 3.45976H33.6316C34.32 3.45976 34.9801 3.73309 35.4665 4.22003C35.9534 4.70635 36.2267 5.36647 36.2267 6.05494V8.33873H21.8674L21.8589 6.05494ZM48.3113 11.7986V54.9273C48.3113 56.7628 47.5824 58.5228 46.2846 59.8208C44.9867 61.1188 43.2266 61.8475 41.391 61.8475H16.7042C14.8687 61.8475 13.1087 61.1186 11.8107 59.8208C10.5127 58.5229 9.78392 56.7628 9.78392 54.9273V11.7986H48.3113Z",
    fill: "#4D7CFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 25.3125H20.3972V50.6404H16.9375V25.3125Z",
    fill: "#4D7CFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6982 25.3125H41.158V50.6404H37.6982V25.3125Z",
    fill: "#4D7CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleBlueIcon);
export default __webpack_public_path__ + "static/media/DeleBlueIcon.0cdaa18deea05351128b99fcad6d6ab2.svg";
export { ForwardRef as ReactComponent };